import { render, staticRenderFns } from "./extra-projektliste.vue?vue&type=template&id=fc13a6d6&scoped=true&lang=pug&"
import script from "./extra-projektliste.vue?vue&type=script&lang=js&"
export * from "./extra-projektliste.vue?vue&type=script&lang=js&"
import style0 from "./extra-projektliste.vue?vue&type=style&index=0&id=fc13a6d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc13a6d6",
  null
  
)

export default component.exports